import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";
import { Locale } from "@/i18n";
import { localePath } from "@/lib/nav";
const luxuryImg = "https://media.lacontessina.com/site/src/assets/luxury-furnishing-details.webp";
export default function LuxuryDetails() {
  const { t, i18n } = useTranslation();
  const locale = (i18n.language as Locale) || "it";

  return (
    <section className="relative w-full py-24 lg:py-36 bg-background">
      <div className="lc-container-ext">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-5 lc-animate-fade-up">
            <span className="lc-eyebrow">{t("home.section.luxury_details.subtitle")}</span>
            <h2 className="mt-6 font-display font-light tracking-[-0.035em] leading-[1.0] text-foreground text-[56px] md:text-[80px] lg:text-[104px]">
              {t("home.section.luxury_details.title_line1")}
              <span className="block italic font-serif font-normal">
                {t("home.section.luxury_details.title_line2").toLowerCase()}
              </span>
            </h2>

            <p
              className="lc-prose mt-8 max-w-[460px] text-[15px] leading-[28px] text-foreground/65"
              dangerouslySetInnerHTML={{ __html: t("home.section.luxury_details.description_html") }}
            />

            <div className="mt-10 flex flex-wrap gap-3">
              <Link to={localePath(locale, "about")} className="lc-btn-solid">
                {t("button.our_story")}
                <ArrowUpRight className="h-4 w-4" />
              </Link>
              <Link to={localePath(locale, "catalogues")} className="lc-btn-outline">
                {t("button.catalogs")}
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7 lc-animate-fade-up lc-animate-delay-1">
            <div className="relative overflow-hidden rounded-[28px] bg-[hsl(var(--surface))] aspect-[5/4]">
              <img
                src={luxuryImg}
                alt={t("home.section.luxury_details.image_alt")}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between text-white">
                <div className="font-serif italic text-[20px] md:text-[26px] leading-[1.2] max-w-xs drop-shadow">
                  {t("home.section.unique_furnishings.title")}
                </div>
                <div className="text-[11px] tracking-[0.3em] uppercase opacity-80">
                  {t("luxury.since")}
                </div>
              </div>
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
